/*
 * Copyright 2025 Intuition Robotics ltd
 */
import * as React from "react";
import {useEffect, useState} from "react";
import {ICONS} from "@res/icons";
import {padding_rl_med} from "@res/styles/styles";
import {COLORS} from "@res/colors";
import {HGap} from "./HGap";
import {FONTS} from "@res/fonts";
import {headHeight, rowHeight} from "../ui/patients/PatientsTable";

export type Pagination = { startIndex: number; endIndex: number };
type Props = {
    tableContent: any[]
    setCurrentPage: (page: number) => void,
    pagination: Pagination
}

export const calculatePagination = (page: number, container: HTMLElement | null) => {
    const clientHeight = container?.offsetHeight;
    if (!clientHeight)
        return {startIndex: 0, endIndex: 1};
    const pagination = Math.floor((clientHeight - headHeight) / rowHeight);
    const startIndex = (page - 1) * pagination;
    const endIndex = startIndex + pagination;
    return {startIndex, endIndex};
};

export const PaginationComponent = (props: Props) => {
    const [page, setPage] = useState(1);
    const pagination = props.pagination;

    useEffect(() => {
        setPage(1)
        props.setCurrentPage(1)
    }, [props.tableContent.length])

    if (props.tableContent.length === 0 || pagination.endIndex === 0)
        return;

    const ceil = Math.ceil(props.tableContent.length / (pagination.endIndex / page));
    return <div style={{marginBottom: 20}} className={`${padding_rl_med}`}>
        <div className={"ll_h_c"}>
            <div className={"ll_h_c clickable"} style={{marginLeft: -5}} onClick={() => {
                if (page > 1) {
                    const previousPage = page - 1;
                    setPage(previousPage);
                    props.setCurrentPage(previousPage)
                }
            }}>
                {ICONS.icon_arrowhead_xl_left(page > 1 ? COLORS.neutral_text_dark_2 : COLORS.grays_gray_blue, 22)}
            </div>
            <HGap h={8}/>
            <div className={"ll_h_c clickable"} onClick={() => {
                if (page < ceil) {
                    const nextPage = page + 1;
                    setPage(nextPage);
                    props.setCurrentPage(nextPage)
                }
            }}>
                {ICONS.icon_arrowhead_xl_right(page <= ceil ? COLORS.neutral_text_dark_2 : COLORS.grays_gray_blue, 22)}
            </div>
            <HGap h={16}/>
            {pagination && FONTS.reg_14_secondary_dark(`Showing ${page} of ${ceil || 1} ${ceil > 1 ? "pages" : "page"}`)}
        </div>
    </div>;

}
